import { render, staticRenderFns } from "./ConsultCards.vue?vue&type=template&id=44173032&"
import script from "./ConsultCards.vue?vue&type=script&lang=js&"
export * from "./ConsultCards.vue?vue&type=script&lang=js&"
import style0 from "./ConsultCards.vue?vue&type=style&index=0&id=44173032&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports